import { Moment } from 'moment';

import { FileLink } from '../file-link.model';
import { User } from '../user.model';

export interface Commentable {
  id: number;

  comments: Comment[];
}

/**
 * Model for API TimelineCommentReply Model
 */
export class Comment {
  /**
   * Auto-generated identifier.
   */
  id: number;

  /**
   * Parent of the comment
   */
  parent: Commentable;

  /**
   * Author, based on API CustomerContact model
   */
  author: User;

  /**
   * Date of reception of the reply.
   */
  createdAt: Moment;

  /**
   * The content of the comment.
   */
  body = '';

  /**
   * List of binary files attached to thread, only 1 for now
   */
  files: File[];

  /**
   * List of summary of files attached to thread
   */
  links: FileLink[];

  /**
   * List of users directly concerned by the comment
   */
  users: User[] = [];

  constructor(attributes: Partial<Comment> = {}) {
    Object.assign(this, attributes);
  }
}
